import { createTheme } from "@mui/material/styles";

export const lightTheme  = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#fc0000',
      light: 'rgba(218, 46, 49, 0.1)',
      dark: 'rgba(218, 46, 49, 0.8)',
    },
    secondary: {
      main: '#aaaaad',
      light: 'rgba(11, 120, 183, 0.1)',
      dark: 'rgba(11, 120, 183, 0.8)',
    },
    warning: {
      main: '#fc0000',
      light: 'rgba(218, 46, 49, 0.1)',
      dark: 'rgba(218, 46, 49, 0.8)',
    },
    info: {
      main: '#ffffff',
      light: 'rgba(255, 255, 255, 0.1)',
      dark: 'rgba(255, 255, 255, 0.8)',
    },
    background: {
      default: '#ffffff',
    },
    common: {
      black: '#000000',
      white: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#aaaaad',
      disabled: '#888888',
    },
    divider: 'rgba(0, 0, 0, 0.1)',
    
  },
  typography: {
    fontFamily: 'Gilroy, Poppins, sans-serif', 
    button: {
      textTransform: "none",
      fontSize: "12px",  // Decreased from 14px
    },
    h1: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "30px",  // Decreased from 32px
      color: "#000000",
  
    },
    h2: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "26px",  // Decreased from 28px
      color: "#000000",
   
    },
    h3: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "24px",  // Decreased from 24px
      color: "#000000",
  
    },
    h4: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "22px",  // Decreased from 20px
      color: "#000000",
   
    },
    h5: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "20px",  // Decreased from 16px
      color: "#000000",
  
    },
    h6: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "18px",  // Decreased from 14px
      color: "#000000",

    },
    subtitle1: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "16px",  // Decreased from 18px
      color: "#000000",
      opacity: "85%",

    },
    subtitle2: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "14px",  // Decreased from 16px
      color: "#000000",
      opacity: "85%",

    },
    body1: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "16px",  // Decreased from 14px
      color: "#000000",
   
    },
    body2: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "14px",  // Decreased from 12px
      color: "#000000",
 
    },
    caption: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "12px",   // Decreased from 10px
      color: "#000000",

    },
    overline: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "10px",   // Decreased from 8px
      color: "#000000",
    },
  },  
  
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#aaaaad",
            color: "#000000",
            border: "1px solid #fc0000",
          },
          textTransform: "capitalize",
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "14px",
          borderRadius: "8px",
          height: "38px",
          padding: "8px 20px",
          width: "auto",
          color: "#ffffff",
          backgroundColor: "#fc0000",

        },
        outlined: {
          '&:hover': {
            color: '#000000',
            border: "1.5px solid #aaaaad",
            backgroundColor: '#aaaaad',
            '& img': {
              filter: 'brightness(0) invert(1)',
            },
            '& .MuiTypography-root': {
              color: 'white',
            },
          },
          textTransform: "capitalize",
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "14px",
          borderRadius: "8px",
          height: "38px",
          padding: "8px 20px",
          width: "auto",
          border: "1.5px solid #aaaaad",
          backgroundColor: '#ffffff',
          color: '#aaaaad',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          '& fieldset': {
            borderRadius: '10px',
          },
          '& input::placeholder': {
            fontSize: '14px',
            fontFamily: 'Gilroy, Poppins, sans-serif',
          },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            display: 'none',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          color: "#000000",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          color: "#000000",
          opacity: "70%",
          fontSize: "20px",
        },
        shrink: ({ ownerState }) => ({
          ...(ownerState.shrink && {
            fontSize: "18px !important",
          }),
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "18px",
          lineHeight: "27px",
          color: "#000000",
        },
        notchedOutline: {
          borderColor: "#ccc",
        },
        root: {
          background: "white",
          "&.Mui-focused": {
            background: "#F8F8F9",
            boxShadow: "0px 6px 12px #3C599829",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          color: "#000000",
          fontSize: "16px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: "0px 2px 10px #0000001A",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 5px 20px #0000001A",
          borderRadius: "10px",
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: "0px 5px 20px #0000001A",
          borderRadius: "8px",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          color: "#000000",
          fontSize: "18px",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "18px",
          color: "#000000",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
        },
        option: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "18px",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#000000", // Ensure default color is black
          fontFamily: 'Gilroy, Poppins, sans-serif',
        },
      },
    },
  },
});


export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#fc0000',
      light: 'rgba(218, 46, 49, 0.3)', // Slight adjustment for dark mode
      dark: 'rgba(218, 46, 49, 0.8)',
    },
    secondary: {
      main: '#aaaaad',
      light: 'rgba(11, 120, 183, 0.3)', // Adjusted for visibility in dark mode
      dark: 'rgba(11, 120, 183, 0.8)',
    },
    warning: {
      main: '#FF8C00',
      light: 'rgba(255, 140, 0, 0.3)', // Adjusted orange for warning
      dark: 'rgba(255, 140, 0, 0.8)',
    },
    info: {
      main: '#ffffff',
      light: 'rgba(255, 255, 255, 0.1)',
      dark: 'rgba(255, 255, 255, 0.8)',
    },
    background: {
      default: '#121212', // Typical dark mode background
      paper: '#1e1e1e',   // Card/panel background
    },
    common: {
      black: '#000000',
      white: '#ffffff',
    },
    text: {
      primary: '#ffffff',
      secondary: '#cccccc', // Slightly lighter text for secondary elements
      disabled: '#888888',  // Disabled text color
    },
    divider: 'rgba(255, 255, 255, 0.1)', // Subtle divider color
  },
  typography: {
    fontFamily: 'Gilroy, Poppins, sans-serif',
    button: {
      textTransform: "none",
      fontSize: "12px",
    },
    h1: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "30px",
      color: "#ffffff",
    },
    h2: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "26px",
      color: "#ffffff",
    },
    h3: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "24px",
      color: "#ffffff",
    },
    h4: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "22px",
      color: "#ffffff",
    },
    h5: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "20px",
      color: "#ffffff",
    },
    h6: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "18px",
      color: "#ffffff",
    },
    subtitle1: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "16px",
      color: "#cccccc",
      opacity: "85%",
    },
    subtitle2: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "14px",
      color: "#cccccc",
      opacity: "85%",
    },
    body1: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "16px",
      color: "#ffffff",
    },
    body2: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "14px",
      color: "#cccccc",
    },
    caption: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "12px",
      color: "#888888",
    },
    overline: {
      fontFamily: 'Gilroy, Poppins, sans-serif',
      fontSize: "10px",
      color: "#888888",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e', // Dark background for app bar
          boxShadow: "0px 4px 6px rgba(0,0,0,0.5)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#555555",
            color: "#ffffff",
            border: "1px solid #fc0000",
          },
          textTransform: "capitalize",
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "14px",
          borderRadius: "8px",
          height: "38px",
          padding: "8px 20px",
          width: "auto",
          color: "#ffffff",
          backgroundColor: "#fc0000",
        },
        outlined: {
          '&:hover': {
            color: '#ffffff',
            border: "1.5px solid #aaaaad",
            backgroundColor: '#555555',
          },
          textTransform: "capitalize",
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "14px",
          borderRadius: "8px",
          height: "38px",
          padding: "8px 20px",
          width: "auto",
          border: "1.5px solid #555555",
          backgroundColor: '#1e1e1e',
          color: '#cccccc',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          '& fieldset': {
            borderRadius: '10px',
          },
          '& input::placeholder': {
            fontSize: '14px',
            fontFamily: 'Gilroy, Poppins, sans-serif',
            color: '#cccccc',
          },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            display: 'none',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          color: "#cccccc",
          opacity: "70%",
          fontSize: "20px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          fontFamily: 'Gilroy, Poppins, sans-serif',
          fontSize: "18px",
          lineHeight: "27px",
          color: "#ffffff",
        },
        notchedOutline: {
          borderColor: "#555555",
        },
        root: {
          background: "#1e1e1e",
          "&.Mui-focused": {
            background: "#2a2a2a",
            boxShadow: "0px 6px 12px #00000029",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: "0px 2px 10px #0000001A",
          backgroundColor: "#1e1e1e",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 5px 20px #0000001A",
          backgroundColor: "#1e1e1e",
          borderRadius: "10px",
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: "0px 5px 20px #0000001A",
          backgroundColor: "#1e1e1e",
          borderRadius: "8px",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#ffffff", // Ensure default color is white
          fontFamily: 'Gilroy, Poppins, sans-serif',
        },
      },
    },
  },
});

